import { computed, defineComponent, ref, watch } from 'vue';
import InputNumber from '../../input-number';
import classNames from '../../_util/classNames';
const ColorSteppers = defineComponent({
    name: 'ColorSteppers',
    props: ['prefixCls', 'value', 'min', 'max', 'onChange', 'formatter'],
    setup(props) {
        const colorSteppersPrefixCls = computed(() => `${props.prefixCls}-steppers`);
        const stepValue = ref(props.value);
        watch(() => props.value, val => {
            if (!Number.isNaN(val)) {
                stepValue.value = val;
            }
        }, { immediate: true });
        return () => (<InputNumber class={classNames(colorSteppersPrefixCls.value)} hideControls min={props.min} max={props.max} value={stepValue.value} formatter={props.formatter} size="small" onChange={step => {
                if (!props.value) {
                    stepValue.value = (step || 0);
                }
                props.onChange?.(step);
            }}/>);
    },
});
export default ColorSteppers;
